<template>
  <a v-on:click.stop.prevent="click" class="boutonRond">
    <ThemedIcon name="flash.png" />
  </a>
</template>

<script>
import ThemedIcon from "@/components/util/ThemedIcon";
import { idyuJsonRpc } from "@/assets/js/idyu/connect.js";

export default {
  name: "FlashButton",
  components: { ThemedIcon },
  props: {
    profile: {
      type: Object,
      default: null
    },

    disabled: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    click: async function() {
      if (this.disabled) {
        await alert(
          "Votre profil est en cours de modération !<br/><br/>" +
            "Vous pourrez envoyer des flash une fois votre profil vérifié."
        );
      } else {
        await idyuJsonRpc("sendFlash", this.profile.id);
        await alert("Votre flash a bien été envoyé !");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.disabled {
  background-color: rgba(0, 0, 0, 0.2);
}
</style>
